import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { RouteComponentProps } from 'react-router';
import { CategoryIndex } from '../../components/CategoryIndex';
import { AsyncLoader } from '../../components/Common/AsyncLoader';
import {
  STORE_ADVERT,
  STORE_CATEGORY,
  STORE_VIDEO,
  AdvertSlot
} from '../../constants';
import { Category } from '../../models/Category';
import { AdvertStore, CategoryStore, VideoStore } from '../../stores';
import './style.css';

// tslint:disable-next-line no-any
export interface SubcategoryPageProps extends RouteComponentProps<any> {
  /* [STORE_CATEGORY]: CategoryStore; */
  subCategory: Category;
}

export interface SubcategoryPageState {
  /* empty */
}

@inject(STORE_ADVERT)
@inject(STORE_CATEGORY)
@inject(STORE_VIDEO)
@observer
export class SubcategoryPage extends React.Component<
  SubcategoryPageProps,
  SubcategoryPageState
> {
  // Initial render
  async componentDidMount() {
    await this.fetchCategoryVideos();
  }

  // Prop updates (e.g. when navigating from subcategory to subcategory)
  async UNSAFE_componentWillReceiveProps() {
    await this.fetchCategoryVideos();
  }

  render() {
    const advertStore = this.props[STORE_ADVERT] as AdvertStore;
    const {
      location,
      match: { url }
    } = this.props;
    const subCategory = this.getSubcategoryForRoute();
    const videoStore = this.props[STORE_VIDEO] as VideoStore;

    const loading =
      !subCategory ||
      !subCategory.videos ||
      videoStore.categoryVideosLoading.running;

    return (
      <AsyncLoader
        className="video-mini-list-loader video-mini-list-videos"
        error={!!videoStore.categoryVideosLoading.error}
        errorMessage={`Sorry, an error occurred while trying to load the videos for this category.`}
        loading={loading}
        pageUrl={url}
      >
        <CategoryIndex
          advertSlotOne={advertStore.adverts[AdvertSlot.CategoryIndexOne]}
          advertSlotTwo={advertStore.adverts[AdvertSlot.CategoryIndexTwo]}
          location={location}
          category={subCategory as Category}
        />
      </AsyncLoader>
    );
  }

  private fetchCategoryVideos = async (): Promise<void> => {
    const categoryStore = this.props[STORE_CATEGORY] as CategoryStore;

    const advertStore = this.props[STORE_ADVERT] as AdvertStore;

    await advertStore.fetchAdvertsForSlot(AdvertSlot.CategoryIndexOne);
    await advertStore.fetchAdvertsForSlot(AdvertSlot.CategoryIndexTwo);

    await categoryStore.fetchCategories();

    const subCategory = this.getSubcategoryForRoute();

    if (!subCategory) {
      return;
    }

    const videoStore = this.props[STORE_VIDEO] as VideoStore;

    await videoStore.fetchVideosForCategory(subCategory);
  };

  private getSubcategoryForRoute = (): Category | undefined => {
    const categoryStore = this.props[STORE_CATEGORY] as CategoryStore;
    const { match } = this.props;

    const category = categoryStore.categories.find(
      _category => _category.relativeRoute === match.params.category
    );

    if (!category || !category.children) {
      return;
    }

    return category.children.filter(
      subCategory => subCategory.relativeRoute === match.params.subCategory
    )[0];
  };
}

export default SubcategoryPage;



// WEBPACK FOOTER //
// ./src/app/containers/SubcategoryPage/index.tsx